import { ReactNode } from 'react';

interface UserWelcomeContainerProps {
	title?: ReactNode;
	subtitle?: string;
}

const UserWelcomeContainer = ({
	title = 'Boas-vindas',
	subtitle = 'Vamos iniciar seu cadastro!',
}: UserWelcomeContainerProps) => {
	const logoProfessional =
		'https://res.cloudinary.com/dd5pbp2tb/image/upload/v1770986601/Icon_dz4cwq.png';
	return (
		<>
			<div className="flex flex-col items-center">
				<div className="overflow-hidden rounded-full shadow-sm shadow-zinc-400">
					<img
						src={logoProfessional}
						className="size-10 shadow-sm "
						alt="Logotipo"
					/>
				</div>
				<div className="text-2xl">
					<span className="leading- font-black text-sky-900">
						Plumaa
					</span>
				</div>
			</div>
			<div className="text-center text-dark">
				<h3 className="text-2xl font-semibold leading-8">{title}</h3>
				<p className="text-md text-dark">{subtitle}</p>
			</div>
		</>
	);
};

export { UserWelcomeContainer };
